export const JumpCodeList = [
	
		{
			code: "9310001140",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=557"
		},
		{
			code: "9310001141",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=558"
		},
		{
			code: "9310001318",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=547"
		},
		{
			code: "9310001595",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=224"
		},
		{
			code: "9310001702",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=242"
		},
		{
			code: "9310001752",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=269"
		},
		{
			code: "9310001756",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=273"
		},
		{
			code: "9310001757",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=274"
		},
		{
			code: "9310001758",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=275"
		},
		{
			code: "9310002226",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=373"
		},
		{
			code: "9310002226",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=373"
		},
		{
			code: "9310002390",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=411"
		},
		{
			code: "9310002399",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=418"
		},
		{
			code: "9310002400",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=419"
		},
		{
			code: "9310002402",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=421"
		},
		{
			code: "9310002403",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=422"
		},
		{
			code: "9310002421",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=425"
		},
		{
			code: "9310002448",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=448"
		},
		{
			code: "9310002549",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=478"
		},
		{
			code: "9310002551",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=480"
		},
		{
			code: "9310002795",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=540"
		},
		{
			code: "9310002838",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=545"
		},
		{
			code: "9310003078",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=95"
		},
		{
			code: "9310003173",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=121"
		},
		{
			code: "9310003188",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=136"
		},
		{
			code: "9310003189",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=137"
		},
		{
			code: "9310003222",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=138"
		},
		{
			code: "9310003233",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=149"
		},
		{
			code: "9310003234",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=150"
		},
		{
			code: "9310003245",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=160"
		},
		{
			code: "9310001455",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=180"
		},
		{
			code: "9310001456",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=181"
		},
		{
			code: "9310001457",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=182"
		},
		{
			code: "9310001458",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=183"
		},
		{
			code: "9310001459",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=184"
		},
		{
			code: "9310001464",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=185"
		},
		{
			code: "9310001482",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=188"
		},
		{
			code: "9310001484",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=190"
		},
		{
			code: "9310001489",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=195"
		},
		{
			code: "9310001490",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=196"
		},
		{
			code: "9310001492",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=198"
		},
		{
			code: "9310001493",
			url: "https://www.pingjicu.com/index.php?m=home&c=View&a=index&aid=199"
		}
	
]


// WEBPACK FOOTER //
// ./src/view/components/index.js